"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItemCheckbox = void 0;
var React = require("react");
var DropList_styles_1 = require("./DropList.styles");
var DropListItemCheckbox = function (_a) {
    var Value = _a.Value, OnClick = _a.OnClick, children = _a.children;
    var ref = React.createRef();
    React.useEffect(function () {
        ref.current.checked = Value;
    }, [Value, ref]);
    var handleLinkClick = function (e) {
        // stopping propagation so we can see the checkbox change.
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        var value = false;
        if (e.target === ref.current) {
            value = ref.current.checked;
        }
        else {
            value = !ref.current.checked;
        }
        if (OnClick) {
            OnClick(value);
        }
        ref.current.checked = value;
    };
    return (React.createElement(DropList_styles_1.MenuRow, { role: "none" },
        React.createElement(DropList_styles_1.ClickRow, { role: "menuitem", tabIndex: -1, onClick: handleLinkClick },
            React.createElement(DropList_styles_1.IconBlock, null,
                React.createElement("input", { ref: ref, readOnly: true, type: "checkbox", defaultChecked: Value })),
            React.createElement(DropList_styles_1.Caption, null, children))));
};
exports.DropListItemCheckbox = DropListItemCheckbox;
